import { supabase } from "@/integrations/supabase/client";

export const sendTransactionalEmail = async (
  template: 'welcome' | 'payment_confirmation',
  to: string,
  data: Record<string, string>
) => {
  const { data: result, error } = await supabase.functions.invoke('send-transactional-email', {
    body: { template, to, data },
  });

  if (error) {
    console.error('Failed to send transactional email:', error);
    throw error;
  }

  return result;
};

export const sendWelcomeEmail = async (email: string, userName: string) => {
  return sendTransactionalEmail('welcome', email, { userName });
};

export const sendPaymentConfirmationEmail = async (
  email: string,
  data: {
    userName: string;
    activityType: string;
    activityName: string;
    amount: string;
    transactionCode: string;
    paidAt: string;
  }
) => {
  return sendTransactionalEmail('payment_confirmation', email, data);
};
